"use strict";
var _StoreItemImpl_data;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const lodash_get_1 = tslib_1.__importDefault(require("lodash.get"));
const getItemsPayload_1 = require("../../../../../src/shared/getItemsPayload");
class StoreItemImpl {
    constructor(response) {
        _StoreItemImpl_data.set(this, []);
        tslib_1.__classPrivateFieldSet(this, _StoreItemImpl_data, response.data, "f");
        const data = response.data.data.map((item) => ({
            ...item,
            meta: {
                ...item.meta,
                category_id: (0, lodash_get_1.default)(item, 'relationships.category.data.id', 0),
            },
        }));
        response.data.data = data;
        const deserialized = (0, getItemsPayload_1.getItemsDeserializeFromApi)(response);
        tslib_1.__classPrivateFieldSet(this, _StoreItemImpl_data, deserialized.data, "f");
    }
    findByQuery(query) {
        const querySearch = String((query === null || query === void 0 ? void 0 : query.q) || '').toLowerCase();
        const regexep = new RegExp(querySearch, 'gi');
        if (query === null || query === void 0 ? void 0 : query.q) {
            tslib_1.__classPrivateFieldSet(this, _StoreItemImpl_data, tslib_1.__classPrivateFieldGet(this, _StoreItemImpl_data, "f").filter((item) => (item.title.match(regexep) || []).length > 0), "f");
        }
        if (query === null || query === void 0 ? void 0 : query.category_id) {
            tslib_1.__classPrivateFieldSet(this, _StoreItemImpl_data, tslib_1.__classPrivateFieldGet(this, _StoreItemImpl_data, "f").filter((item) => Number(item.meta.category_id) === Number(query.category_id || 0)), "f");
        }
        if ((query === null || query === void 0 ? void 0 : query.sort) && query.sort === 'price_per_day_cents') {
            tslib_1.__classPrivateFieldGet(this, _StoreItemImpl_data, "f").sort((current, next) => current.price_per_day_cents - next.price_per_day_cents);
        }
    }
    get data() {
        return tslib_1.__classPrivateFieldGet(this, _StoreItemImpl_data, "f");
    }
}
exports.default = StoreItemImpl;
_StoreItemImpl_data = new WeakMap();
//# sourceMappingURL=index.js.map